export enum SharePresetStateEnum {
  ERROR = 'error',
  LOADING = 'loading',
  FINISHED = 'finished',
}